import { render, staticRenderFns } from "./TestScreen.vue?vue&type=template&id=37fb9ad9&"
import script from "./TestScreen.vue?vue&type=script&lang=js&"
export * from "./TestScreen.vue?vue&type=script&lang=js&"
import style0 from "./TestScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports